export default "__VITE_ASSET__5230fc21__"